// @ts-nocheck
// Cellegant cart AOV actions — subscribe swap + buy/upgrade to 2 jars.
// Both actions = add(target variant, plan?) then remove(source line), then re-render
// the cart drawer via the Section Rendering API. Robust against morph edge cases.
import { morphSection } from '@theme/section-renderer';
import { CartUpdateEvent } from '@theme/events';

(function () {
  if (window.__cgCartBound) return;
  window.__cgCartBound = true;

  var R = (typeof Theme !== 'undefined' && Theme.routes) ? Theme.routes : {};
  var ADD = R.cart_add_url || '/cart/add.js';
  var CHANGE = R.cart_change_url || '/cart/change.js';
  var CART = (R.cart_url || '/cart') + '.js';

  function sectionId() {
    var el = document.querySelector('cart-items-component[data-section-id]');
    return el ? el.dataset.sectionId : null;
  }

  async function post(url, body) {
    var res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    var data = null;
    try { data = await res.json(); } catch (e) {}
    if (!res.ok) {
      var err = new Error('cart request failed (' + res.status + ')');
      err.data = data;
      throw err;
    }
    return data;
  }

  // Re-render the cart drawer independently of the mutation response.
  async function rerender(sid) {
    var res = await fetch(location.pathname + '?sections=' + encodeURIComponent(sid), {
      headers: { Accept: 'application/json' },
    });
    var map = await res.json();
    if (map && map[sid]) {
      await morphSection(sid, map[sid], { mode: 'hydration' });
    }
    var cart = {};
    try { cart = await (await fetch(CART, { headers: { Accept: 'application/json' } })).json(); } catch (e) {}
    document.dispatchEvent(
      new CartUpdateEvent(cart, sid, { source: 'cg-cart', itemCount: cart.item_count })
    );
  }

  function lock(btn) {
    if (!btn) return;
    btn.dataset.cgLabel = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('cg-ups--busy');
    btn.textContent = 'Updating…';
  }
  function restore(btn) {
    if (!btn || !document.body.contains(btn)) return;
    btn.disabled = false;
    btn.classList.remove('cg-ups--busy');
    if (btn.dataset.cgLabel) btn.innerHTML = btn.dataset.cgLabel;
  }

  // add target variant (with optional plan), then remove the source line
  async function addThenRemove(variant, qty, plan, sourceKey) {
    var item = { id: Number(variant), quantity: qty || 1 };
    if (plan) item.selling_plan = Number(plan);
    await post(ADD, { items: [item] });
    if (sourceKey) await post(CHANGE, { id: sourceKey, quantity: 0 });
  }

  async function run(btn, task) {
    var sid = sectionId();
    if (!sid) return;
    lock(btn);
    try {
      await task();
      await rerender(sid);
    } catch (e) {
      console.error('[cg-cart]', e, e && e.data);
      restore(btn);
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var swap = e.target.closest('[data-cg-swap]');
    if (swap) {
      e.preventDefault();
      run(swap, function () {
        return addThenRemove(
          swap.getAttribute('data-cg-variant'),
          parseInt(swap.getAttribute('data-cg-qty'), 10) || 1,
          swap.getAttribute('data-cg-plan'),
          swap.getAttribute('data-cg-line')
        );
      });
      return;
    }

    var up = e.target.closest('[data-cg-upgrade]');
    if (up) {
      e.preventDefault();
      run(up, function () {
        return addThenRemove(
          up.getAttribute('data-cg-variant'),
          1,
          up.getAttribute('data-cg-plan'),
          up.getAttribute('data-cg-line')
        );
      });
    }
  });
})();
